import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import ProjectorProduct from '../components/projectorProduct/ProjectorProduct';

const ProjectorProductPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <ProjectorProduct />
            </main>

            <TopButton />
        </>
    );
};

export default ProjectorProductPage;